var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "price", class: _vm.pricingClass }, [
    _vm._v("\n  " + _vm._s(_vm._f("toPrice")(_vm.displayPrice)) + "\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }